import __request__ from "routing/request";
export function validateQuery(validationRequest, requestOptions) {
  return __request__("POST", "/search/validate", validationRequest, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
